import { Component, OnInit, Input } from '@angular/core';
import { FundraiserService, UtilService } from '../../../shared/services';

@Component({
  selector: 'app-active-fundraisers',
  templateUrl: './active-fundraisers.component.html',
  styleUrls: ['./active-fundraisers.component.scss']
})
export class ActiveFundraisersComponent implements OnInit {

  @Input() section;
  @Input() cause;
  campaings;
  tag = 'mostfunded';
  isLoading;

  constructor(
    private fundraiserService: FundraiserService,
    public utilService: UtilService
  ) { }

  ngOnInit() {
    this.getCampaigns(0);
  }

  getCampaigns(page) {
    this.isLoading = true;
    const qparam = {
      limit: 3,
      offset: page,
      filter: `category=${this.cause}`
    }
    this.fundraiserService.getCampaignsMeilisearch(qparam).subscribe((res: any) => {
      this.campaings = page === 0 ? res : { ...res, hits: this.campaings.hits.concat(res.hits) };
      this.isLoading = false;
    }, () => this.isLoading = false);
  }

}
